import { render, staticRenderFns } from "./HolidayDetail.vue?vue&type=template&id=326d5432&scoped=true"
import script from "./HolidayDetail.vue?vue&type=script&lang=js"
export * from "./HolidayDetail.vue?vue&type=script&lang=js"
import style0 from "./HolidayDetail.vue?vue&type=style&index=0&id=326d5432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326d5432",
  null
  
)

export default component.exports